import type { KeyboardEvent } from 'react';

import { MenuItem } from '@shared/ui/menu';

import { ACCOUNT_MENU_ITEMS, type AccountMenuItem } from '../model/account-menu';
import { ACCOUNT_MENU_TEXT } from '../model/account-menu.text';

export interface AccountMenuProps {
  /** Figma `role`. member 는 D3 · LP · PF 모두 */
  role: 'admin' | 'member';
  onSelect: (item: 'info' | 'config' | 'access-log' | 'logout') => void;
}

/** 위 · 아래 · Home · End 로 항목 사이를 옮긴다 */
function moveFocus(event: KeyboardEvent<HTMLDivElement>) {
  const items = Array.from(
    event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="menuitem"]'),
  );
  const index = items.indexOf(document.activeElement as HTMLButtonElement);
  const last = items.length - 1;
  const next =
    event.key === 'ArrowDown'
      ? index >= last
        ? 0
        : index + 1
      : event.key === 'ArrowUp'
        ? index <= 0
          ? last
          : index - 1
        : event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? last
            : null;
  if (next === null) return;
  event.preventDefault();
  items[next]?.focus();
}

/**
 * 헤더의 설정 아이콘 아래에 뜨는 계정 메뉴. 목록만 그린다 — 여닫기는 상위(GlobalHeader)가 맡는다.
 * Menu atom 의 틀(모서리 · 그림자)은 쓰지 않고 항목(`_Menu/Item`)만 쓴다.
 */
export function AccountMenu({ role, onSelect }: AccountMenuProps) {
  return (
    <div
      role="menu"
      aria-label={ACCOUNT_MENU_TEXT.label}
      data-slot="account-menu"
      data-role={role}
      onKeyDown={moveFocus}
      className="flex w-(--size-button-lg) flex-col border border-border-subtle bg-bg-surface"
    >
      {ACCOUNT_MENU_ITEMS[role].map((item: AccountMenuItem, index) => (
        <MenuItem key={item} tabIndex={index === 0 ? 0 : -1} onSelect={() => onSelect(item)}>
          {ACCOUNT_MENU_TEXT[item]}
        </MenuItem>
      ))}
    </div>
  );
}
